
<template>
  <v-app id="searchHsav">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>Host cancellation terms</v-card-title>
      <v-simple-table dense>
         <tbody v-for="(hsavRecord,i) in searchHsav" :key="i">
           <tr @click="$router.reload('/syst/ref/hsav/onHsav/' + hsavRecord.hsav_encrid)">
             <td>{{hsavRecord.hsav_nr}}</td>
             <td>{{hsavRecord.hsav_oms}}</td>
           </tr>  
         </tbody>  
       </v-simple-table>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>    
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar,
  },
  data() {
    return {
      searchHsav: []
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/hsav/searchHsav.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchHsav"
          },
          searchHsav: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchHsav = res.data.searchHsav;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
};

</script> 
